import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,message,Layout, Space,Modal,Select,Radio, AutoComplete,Image,Progress } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import {api_interviewer_add, api_interviewer_edit} from '../../../api';

// const navigate = useNavigate();
  // navigate(-1)//适用于返回上级页面
  // navigate('/router');//也可直接加路径

const { TextArea } = Input;
const screenHeight = document.body.clientHeight;
let followOptions={follow:[], follow_email:[], follow_phone:[]};

const App =(props)=>{
    const {showModal, closeModal, rowInfo, refreshlist} = props;
    console.log('1111111111111111111111111111111111111-', rowInfo)
    const [form] = Form.useForm();
    const [bEdit,setBEdit] = useState(true);
    const [loading,setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [attpercent, setAttpercent] = useState(0);
    const [attpercentShow,setAttpercentShow] = useState(false);

    useEffect(() => {
      if(showModal){
        if(rowInfo.interviewer_id == undefined){
          form.resetFields();
          setImageUrl("");
        } else {
          for (let key in rowInfo) {
            form.setFieldValue(key, rowInfo[key])
          }
          setImageUrl(rowInfo.logo);
        }
      }else{
        form.resetFields();
        setLoading(false);
        setImageUrl("");
        setAttpercent(0);
        setAttpercentShow(false);
      }
    }, [showModal]);

    // const mockVal = (str, repeat = 1) => ({
    //   value: str.repeat(repeat),
    // });
    
    // const onSearch = (searchText) => {
    //   setOptions(
    //     !searchText ? [] : [mockVal(searchText), mockVal(searchText, 2), mockVal(searchText, 3)],
    //   );
    // };
    // const onSelect = (data) => {
    //   console.log('onSelect', data);
    // };
    // const onChange = (data) => {
    //   setValue(data);
    // };

    const setOptions = async(key, value)=>{
      if(value){
        for(let item of followOptions[key]){
          if(item.value == value)
            return;
        }
        followOptions[key].push({value:value});
      }
    };

    const onFinish = async(value)=>{
      console.log(value);
      // value.logo = imageUrl;
      // setLoading(true);

      value.interviewer_id = rowInfo.interviewer_id;
      var fun = rowInfo.interviewer_id ? api_interviewer_edit : api_interviewer_add;

      try {
        await fun(value).then((res) => {
          setLoading(false);
          console.log(fun+'-res-----------------', res);
          if (res.data.code == 9) {
            message.success("操作成功");
            closeModal();
            refreshlist();
          }else
            message.error(res.data.msg);
        });
        } catch (error) {
          message.error("网络异常");
          setLoading(false);
          return false;
        }
  }

  return (
    <Modal 
        key="interviewerinfo"
        title={(rowInfo.interviewer_id ? '编辑' :'新增')+'面试官'}
        open={showModal}
        width={600}
        bodyStyle={{maxHeight:screenHeight*0.8,overflowY:"scroll"}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeModal}>
        取消
        </Button>,
        <Button type="primary" loading={loading} style={{ marginLeft:'20px',backgroundColor:"rgb(24,188,156)"}} onClick={()=>{form.submit()}}>
        确认
        </Button>] }
        onCancel={closeModal}>
          <Form form={form}
            className='loginForm reginfo'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            layout="horizontal"
            // onFinishFailed={this.onFinishFailed}
            autoComplete="off"
            labelAlign="left"
            labelCol={{span:5}}
            // style={{fontSize:12}}
            size="small"
            initialValues={{is_outlook_enabled:"0"}}
        >
            <Form.Item
                label="姓名"
                name="name"
                rules={[
                  {required: true, message: '请输入姓名',},
                ]}
            >
            <Input />
            </Form.Item>
            <Form.Item
                label="手机"
                name="phone"
                rules={[
                  // {required: true, message: '请输入电话',},
                  {
                    pattern: /^1[3-9]\d{9}$/,
                    message: '请输入有效的手机号码',
                  },
                ]}
            >
            <Input />
            </Form.Item>
            <Form.Item
                label="邮箱"
                name="email"
                rules={[
                  {required: true, message: '请输入邮箱',},
                  {
                    type: 'email',
                    message: '请输入有效的邮箱地址',
                  },
                ]}
            >
            <Input  disabled={rowInfo.interviewer_id?true:false} />
            </Form.Item>
            <Form.Item
                label="其他信息"
                name="remark"
            >
            <TextArea rows={4} placeholder="最多100个字" maxLength={100} />
            </Form.Item>

        </Form>
        </Modal>
  )
}
export default App
